export default "__VITE_ASSET__D7DS6z1X__"